import BaseInteraction from './base';
import ScrollbarInteraction from './scrollbar';
import SliderInteraction from './slider';
import TimeLineInteraction from './timeline';
import TooltipIndicatorInteraction from './tooltip-indicator';
BaseInteraction.registerInteraction('slider', SliderInteraction);
BaseInteraction.registerInteraction('scrollbar', ScrollbarInteraction);
BaseInteraction.registerInteraction('timeline', TimeLineInteraction);
BaseInteraction.registerInteraction('tooltip-indicator', TooltipIndicatorInteraction);
export * from './base';
export default BaseInteraction;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/interaction/index.js
// module id = null
// module chunks = 